import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGN_INTENT_VALID_SAMPLE_RATE = createFcmDetails('sign_intent_valid_sample_rate', {
	owner: 'supporters pack',
	context: 'petition page',
	description: `Sampling rate for which the sign_intent_valid event should be tracked.
			For instance, if value is 30, 30% of the sign_intent_valid events will be tracked.
			Default value is 15.
		`,
	import: false,
});
